import React, { useContext } from "react";
import "../landing/Landing.css";
import { Context } from "../../context/Context";
import { Onboarding } from "../../components/landing/Onboarding/Onboarding";
import { Plans } from "../../components/landing/Plans/Plans";
import { WhatsAppFloat } from "../../components/landing/WhatsAppFloat/WhatsAppFloat";

export const PricingPage = () => {
  const { lang } = useContext(Context);

  return (
    <div className={`landing-page ${lang === "ar" ? "ar" : "en"}`}>
      <Onboarding />
      <Plans />
      <WhatsAppFloat />
    </div>
  );
};

export default PricingPage;
